import { httpClient } from "./http-client";
import UsersClient from "./users-client";
import BannersClient from "./banners-client";
import CategoriesClient from "./categories-client";
import ProductsClient from "./products-client";
import SettingsClient from "./settings-client";
import AuthClient from "./auth-client";
import OrdersClient from "./orders-client";
import PaymentMethodsClient from "./payment-methods-client";
import ShippingMethodsClient from "./shipping-methods-client";
import ShippingZonesClient from "./shipping-zones-client";
import CartClient from "./cart-client";
import PaymentClient from "./payment-client";
import RecipesClient from "./recipes-client";
import PageItemsClient from "./page-items-client";
export const bannersClient = new BannersClient(httpClient);
export const categoriesClient = new CategoriesClient(httpClient);
export const productsClient = new ProductsClient(httpClient);
export const settingsClient = new SettingsClient(httpClient);
export const authClient = new AuthClient(httpClient);
export const usersClient = new UsersClient(httpClient);
export const ordersClient = new OrdersClient(httpClient);
export const paymentMethodsClient = new PaymentMethodsClient(httpClient);
export const shippingMethodsClient = new ShippingMethodsClient(httpClient);
export const shippingZonesClient = new ShippingZonesClient(httpClient);
export const cartClient = new CartClient(httpClient);
export const paymentClient = new PaymentClient(httpClient);
export const recipeClient = new RecipesClient(httpClient);
export const pageItemsClient = new PageItemsClient(httpClient);
